<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { MarkComponentProps } from '@portabletext/svelte';
  import { analyticsStore } from '$lib/analytics/store';
  import { modals } from '$lib/stores/modals';
  import LinkDecorator from '../Common/LinkDecorator.svelte';

  interface Props {
    // Property custom marks receive from @portabletext/svelte when rendered
    portableText: MarkComponentProps<{
      _key: string;
      declineCookie?: boolean;
    }>;
    children?: Snippet;
  }

  let { portableText, children }: Props = $props();

  let modalBtn: HTMLElement | undefined = $state();

  function handleOpenModal() {
    analyticsStore.declineAnalytics();
    modals.open('declineCookie', modalBtn);
  }
</script>

{#if portableText.value?.declineCookie}
  <LinkDecorator>
    <button aria-label="Opt out of cookies" bind:this={modalBtn} onclick={handleOpenModal}>
      {@render children?.()}
    </button>
  </LinkDecorator>
{:else}
  {@render children?.()}
{/if}
